import React, { useState } from "react";
import { Col, Card, Row, Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import DeletePopUp from "../Layout/DeletePopUp";
import UseDeleteProduct from "../../CustomHooks/Admin/UseDeleteProduct";


const AdminAllProductsCard = ({ allProductsresponse }) => {
  const [show, handleClose, handleShow, handleDelete] = UseDeleteProduct(allProductsresponse)
  return (
    <>
      <DeletePopUp show={show} handleDeleteItem={handleDelete} handleClose={handleClose} />
      <Col xl="3" lg="4" sm="6">
        <Card className="mb-4 border shadow-sm pt-2 px-3">
          <Card.Img src={allProductsresponse.imageCover} className="admin-card-Img mb-3 d-block mx-auto" />
          <Card.Body className="p-0">
            <Card.Title>
              <div className="fw-bold fs-20">{allProductsresponse.title}</div>
            </Card.Title>
            <Card.Text className="d-flex justify-content-end">
              {allProductsresponse.priceAfterDiscount ? (<><span className="me-2 fw-bold fs-20">{allProductsresponse.priceAfterDiscount} EGP</span> <del className="fs-16 mt-2">{allProductsresponse.price} EGP</del></>) : <p className="fw-bold fs-20 mb-0  dark-color me-2"> {allProductsresponse.price} EGP</p>}
            </Card.Text>
            <Row className='mt-4'>
              <Col>
                <Link to={`/admin/editproduct/${allProductsresponse._id}`}><Button variant="warning" className='w-100 action-button mb-3'>Edit</Button></Link>
              </Col>
              <Col>
                <Button variant="danger" onClick={handleShow} className='w-100 action-button mb-3'>Delete</Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default AdminAllProductsCard;
